"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Marketing, Communication, Technologie de l’Information et de la Communication"}
                                middleBreadcrumbs={[
                                    {title: "L'Office du Tourisme", link: "/espace-pro/office-de-tourisme"},
                                ]}
                                description={"Découvrez l’équipe de l’Office de Tourisme et les missions que nous menons, en faveur du développement touristique de la destination COTE D’IVOIRE"}/>

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">

                <p className={"text-normal mb-8"}>
                    Directeur : Monsieur <strong>KBOUAZO-ZEGBEHI David</strong>
                    <br/>
                    <br/>
                    Il est chargé de :
                </p>

                <div className={"text-normal mb-8"}>
                    <ul className="list-disc list-inside text-lg mt-8">
                        <li className="li2">Définir et de mettre en œuvre la stratégie Marketing&nbsp;: promotion de la
                            destination Côte d’Ivoire ;
                        </li>
                        <li className="li2">Définir la politique globale de communication de Côte d’Ivoire Tourisme ;
                        </li>
                        <li className="li2">Promouvoir la destination Côte d’Ivoire par les Technologies de
                            l’Information et de la Communication ;
                        </li>
                        <li className="li2">Organiser et de coordonner la participation de la Côte d’Ivoire aux
                            manifestations culturelles, sportives et touristiques ;
                        </li>
                        <li className="li2">Coordonner la participation de la Côte d’ivoire aux foires et salons
                            professionnels majeurs ;
                        </li>
                        <li className="li2">Gérer l’accueil et de contribuer au protocole lors des manifestations
                            majeures nationales et internationales.
                        </li>
                    </ul>
                </div>

            </SectionPage>

        </div>
    );
}
